import "./product-detail.js";
import Internal_3838444105 from "react-dom";
import Internal_1493001052 from "react";
import Internal_1979265892 from "./components/detail-header/index.js";
import Internal_1414461266 from "./components/booking";
import Internal_3999627174 from "./components/comments.js";
import Internal_1136996370 from "@components/map";
import Internal_900817642 from "./components/facility/index.js";
import Internal_1201527044 from "./components/recommends";
import "../macros/product.njk";
import "./macros/xiaochengxuhua.njk";
import "../layouts/main.njk";
import "../act/new-user/aside.njk";
$__renderReact(Internal_1979265892, "J-gallery", "hydrate")
$__renderReact(Internal_1414461266, "J-booking", "hydrate")
$__renderReact(Internal_3999627174, "J-comments", "hydrate")
$__renderReact(Internal_1136996370, "order-detail-map", "render")
$__renderReact(Internal_900817642, "J-facility", "hydrate")
$__renderReact(Internal_1201527044, "J-recommends", "hydrate")
function $__renderReact(Component, domId, renderMethod = 'hydrate') {
  const dom = window.document.getElementById(domId)
  if (!dom) return
  const propsNode = window.document.getElementById('r-props-' + domId)
  const propsNodeContent = (propsNode && propsNode.innerHTML) || ''
  const propsContent = propsNodeContent.replace(/^\s*<!--\s*|\s*-->\s*$/g, '').replace(/&gt;/g, '>').replace(/&amp;/g, '&')
  const props = JSON.parse(propsContent)
  const children = props.children || null
  delete props.children
  Internal_3838444105[renderMethod](Internal_1493001052.createElement(Component, props, children), dom)
}
require("./product-detail.less");